'use client'

import Head from 'next/head'
import Image from 'next/image'
import PageBanner from '../PageBanner'
import ContactSection from '../../../app/_components/Section/Contact'
import technologiesData from '../../../app/_utilities/data/sections/vision.json'

const VisionAI = (): JSX.Element => {
  return (
    <>
      <Head>
        <title>Vision AI Tech</title>
      </Head>

      {/* Banner */}
      <PageBanner pageName="Vision AI" pageTitle="Intelligent Vision Powered by AI" />

      {/* Intro */}
      <section className="mil-p-40-10" style={{ paddingTop: 20 }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12 col-xl-6">
              <h4 className="mil-mb-10" style={{ fontSize: '3rem' }}>
                AI-Driven <br />
                <span className="mil-accent">Vision Intelligence</span>
              </h4>
            </div>
            <div className="col-lg-12 col-xl-6">
              <p className="mil-dig-text">
                We are building an AI-powered vision application using images, videos, cameras into
                real-time intelligence systems capable of perception, analysis, and action. <br></br>
                By combining computer vision, video analytics, and edge AI, we enable automation,
                safety monitoring, and data-driven decision-making across industrial, commercial,
                and public environments.
              </p>
            </div>
          </div>
        </div>
      </section>
<br></br>
  
  <section className="mil-p-20-10">
  <div className="container">
    <div className="row">
      <div className="col-12 text-center">
        <h4 className="mil-mb-10" style={{ fontSize: '2rem' }}>
          Applications, Projects and Expertise<br />
         
        </h4>
      </div>
    </div>
  </div>
</section>


      {/* Platform Overview */}
      {/* <section className="mil-deep-bg mil-p-40-0" style={{ paddingTop: 60 }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5 mil-mb-60">
              <img
                src="/img/vision/vision-ai.png"
                alt="Vision AI Platform"
                className="img-fluid"
              />
            </div>
            <div className="col-lg-6">
              <h2 className="mil-mb-50">
                Building Systems <br />
                <span className="mil-accent">That See Beyond Cameras</span>
              </h2>
              <p className="mil-dig-text" style={{ textAlign: 'justify' }}>
                Our AI Vision platform transforms camera streams into intelligent systems capable of
                perception, reasoning, and action — delivering insights and automation directly at
                the edge.
              </p>
            </div>
          </div>
        </div>
      </section> */}

      {/* Technologies We’ve Worked With */}
      <section className="mil-p-40-10">
        <div className="container">
          {technologiesData.technologies.map((tech, index) => (
            <div
              key={index}
              className={`row align-items-center mil-mb-60 ${
                index % 2 === 0 ? 'flex-row-reverse' : ''
              }`}
            >
              <div className="col-lg-6 text-center">
                <Image
                  src={tech.image}
                  alt={tech.title}
                  width={600}
                  height={350}
                  className="img-fluid"
                />
              </div>

              <div className="col-lg-5">
                <h3 className="mil-h3 mil-mb-20">{tech.title}</h3>
                <p className="mil-dig-text" style={{ textAlign: 'justify' }}>
                  {tech.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA / Contact */}
      <ContactSection />
    </>
  )
}

export default VisionAI
